
import { DOWNLOAD } from '@/helpers/enums/table-actions'

export const TABLE_ACTIONS = Object.freeze([
  DOWNLOAD,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Оригинальный вариант',
    value: 'original_variant',
    sortable: false,
  },
  {
    text: 'Количество заданий',
    value: 'total_tasks_count',
    sortable: false,
  },
  {
    text: 'Заданий с GUID',
    value: 'non_null_tasks_count',
    sortable: false,
  },
])
